<template>
  <b-modal
    :title="$t('unshare.title', { item: itemName })"
    :visible="visible"
    size="lg"
    hide-footer
    @change="$emit('change', false)"
  >
    <feather-icon size="30" icon="AlertTriangleIcon" class="d-block mx-auto text-danger mb-1" />
    <h5 class="mb-2 px-2 text-center">
      {{ $t('unshare.message') }}
    </h5>
    <div class="d-flex justify-content-center mb-2 flex-wrap">
      <b-button
        variant="primary"
        target="_blank"
        class="mt-25"
        @click="modalInvisible"
      >
        {{ $t('unshare.options.no') }}
      </b-button>
      <b-button
        variant="outline-danger"
        target="_blank"
        class="ml-md-1 mt-25"
        @click="handleRemoveItem(true)"
      >
        {{ $t('unshare.options.yes') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'UnshareItemModal',
  components: { BButton },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: Boolean,
    modelType: {
      type: String,
      required: true,
    },
  },
  computed: {
    itemName() {
      return this.$t(`unshare.singular-items.${this.modelType}`);
    },
  },
  methods: {
    modalInvisible() {
      this.$emit('modal-invisible')
    },
    handleRemoveItem(response) {
      this.$emit('remove-item', response);
      this.$emit('change', false);
    },
  },
};
</script>
